"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var utils_1 = require("@idp/ui-components/utils");
var ui_components_1 = require("@idp/ui-components");
var InsuranceModelState_1 = require("./InsuranceModelState");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var components_1 = require("@idp/duc/components");
var styles = require("./InsuranceModal.scss");
var ReportingService_1 = require("../../../../api/ReportingService");
var StateProvider_1 = require("../../../../api/StateProvider");
var Api_1 = require("../../../../api/Api");
var Events_1 = require("../../../../api/Events");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var InsuraneModel = /** @class */ (function (_super) {
    __extends(InsuraneModel, _super);
    function InsuraneModel(props) {
        var _this = _super.call(this, props) || this;
        _this.zipCodeUpdateModal = 'CART:zipUpdate';
        _this.state = new InsuranceModelState_1.default();
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.events = new Events_1.default([_this.zipCodeUpdateModal]);
        return _this;
    }
    InsuraneModel.prototype.render = function () {
        return (React.createElement("span", null, this.props.data && this.showCapacityModal()));
    };
    InsuraneModel.prototype.componentDidMount = function () {
        document.querySelector('html').style.overflow = 'hidden';
    };
    InsuraneModel.prototype.showCapacityModal = function () {
        var _this = this;
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('Cart_Insurance', 'Change', 'Modal'), options: {
                show: this.props.data && this.state.showInsuranceModal,
                showClose: false,
                size: ModalProps_1.ModalSizes.SMALL,
                tabIndex: 0,
            }, events: {
                onClose: function () {
                    _this.stateManager.set('zipUpdate', { openModal: false });
                    _this.events.fireEvent({}, _this.zipCodeUpdateModal);
                },
            } },
            React.createElement("div", { className: styles.cartccOptionsContainer },
                React.createElement(components_1.Alert, { closeable: false, type: "warning" }, this.props.cmscontent.moreInsuranceOptions),
                React.createElement("div", { className: styles.text }, this.props.cmscontent.moreInsuranceOptionsLog),
                React.createElement("div", { className: styles.btnDiv },
                    React.createElement(components_1.Button, { testId: utils_1.default('Button', 'Close'), 
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick: function () {
                            _this.stateManager.set('zipUpdate', { openModal: false });
                            _this.events.fireEvent({}, _this.zipCodeUpdateModal);
                            sessionStorage.setItem('isMandateMsgShown', JSON.stringify(true));
                            _this.reportingService.fireLinkClickEvent('Continue', CartUtilFunctions_1.getLinkClickBasekUrl());
                            _this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBaseUrlforNMDPR());
                            _this.setState({ showInsuranceModal: false });
                            _this.stateManager.set('cartUpdate', { cartRefresh: true });
                        }, className: styles.modalButton1 }, this.props.cmscontent.zipChangeOKLabel)))));
    };
    return InsuraneModel;
}(React.Component));
exports.default = InsuraneModel;
//# sourceMappingURL=InsuranceModel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/InsuranceModel/InsuranceModel.js
// module id = 413
// module chunks = 8